import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { ButtonContainer } from './CtaButton.styled.js';
import Button from '@components/Shared/Buttons/Button';
import noop from '@utils/noop.js';

class CtaButton extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (
      this.props.visible !== nextProps.visible ||
      this.props.pristine !== nextProps.pristine
    ) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <ButtonContainer
        visible={this.props.visible}
        pristine={this.props.pristine}
      >
        <Button
          automationId="unbuilt-see-homes-cta"
          onDarkBg={true}
          nextJSUrl="/find-a-home/"
          linkComponent={Link}
          isCompact={true}
          onClick={this.props.onClick || noop}
        >
          See Homes
        </Button>
      </ButtonContainer>
    );
  }
}

CtaButton.propTypes = {
  onClick: PropTypes.any,
  pristine: PropTypes.any,
  visible: PropTypes.any,
};

export default CtaButton;
